import { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { get } from '../../../services/apiController';

const ProductionIndentDetail = ({ isPrint, data }) => {
  const [factory, setFactory] = useState({});
  const [kitchen, setKitchen] = useState({});
  useEffect(() => {
    if (data?.factoryId) {
      get('/branches/?id=' + data.factoryId).then((branch) => {
        if (branch.data.rows.length) {
          setFactory(branch.data.rows[0]);
        }
      });
    }
  }, [data?.factoryId]);
  useEffect(() => {
    if (data?.type === 'previewBeforeSubmit' && data.kitchenId) {
      get('/inv/kitchen/?id=' + data.kitchenId).then((kitchen) => {
        setKitchen(kitchen?.data?.rows[0]);
      });
    }
  }, []);
  return (
    <div className={`grn-detail ${isPrint ? 'print-view me-5 ms-5' : ''}`}>
      <div className="text-center">
        <div className="mb-3">
          <h4 className="m-0 mb-2">Kanti Sweets Private Limited</h4>
          <h6 className="m-0" style={{ fontSize: '11px' }}>
            {factory?.name}
            <br />
            {factory?.address}
          </h6>
        </div>
        <div>
          <h5 className="mb-2">
            <b>
              <u>Production Indent</u>
            </b>
          </h5>
        </div>
      </div>
      <Table bordered striped responsive className="mt-3">
        <tbody>
          <tr>
            <th>Production Indent Number</th>
            <td>{data?.productionIndentNumber}</td>
            <th>Kitchen Name</th>
            <td>{kitchen?.name ?? data?.Kitchen?.name}</td>
          </tr>
        </tbody>
      </Table>

      <Table striped bordered className="text-center grn-detail-table">
        <thead>
          <tr>
            <th colSpan={6}>Order Details</th>
          </tr>
          <tr>
            <th>Sl No.</th>
            <th>Item Name</th>
            <th>HSN Code</th>
            <th>Unit</th>
            <th>Req Qty</th>
            <th>Issued Qty</th>
          </tr>
        </thead>
        <tbody>
          {data?.ProductionIndentDetails?.map((item, index) => {
            return (
              <tr>
                <td>{index + 1}</td>
                <td>{item?.name ?? item?.Item?.name}</td>
                <td>{item?.hsnCode ?? item?.Item?.hsnCode}</td>
                <td>{item?.unit ?? item?.Item?.unit}</td>
                <td>{item?.requisitionQuantity}</td>
                <td>{item?.issuedQuantity}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      {isPrint && (
        <Table style={{ width: '100%', marginTop: '60px' }}>
          <tfoot>
            <tr>
              <td width="33.33%">
                <h6>Raised By</h6>
              </td>
              <td width="33.33%" align="center">
                <h6>Issued By</h6>
              </td>
              <td width="33.33%" align="right">
                <h6>Received By</h6>
              </td>
            </tr>
          </tfoot>
        </Table>
      )}
    </div>
  );
};

export default ProductionIndentDetail;
